import React from 'react';
import '@coreui/coreui/dist/css/coreui.min.css';
import  Carousel  from '../../components/Carousel.js';
import Cards from '../../components/Cards.js';
//import Footer from '../../components/Footer';
import './Anestesia.css'; // Importa los estilos específicos

function Anestesia() {
  return (
    <div>

      <div style={{ margin: '5rem 0' }}>
        <Carousel />
      </div>
      
      <div className='anestesia-grid'>
          <div className='anestesia-item'> 
              <h2>¿Qué es la anestesia?</h2>
          </div>
          <div className='anestesia-item anestesia-bg'> 
              <p>Es un estado de <strong>inconsciencia e insensibilidad</strong> temporal, que se consigue administrando una serie de medicamentos intravenosos, inhalados, en la piel y tejidos profundos en algunos casos.</p>
          </div>
      </div>

      <div>
        <Cards />
      </div>

     
    </div>
  );
}

export default Anestesia;
